import Content from '../../content.js';
import Modal from '../../components/modal';

namespace('IO.Views.NodeGroups', function (exports) {
  'use strict';

  var TemplateNameGenerator = IO.Views.Components.TemplateNameGenerator,
    DynamicGroupForm = IO.Views.Components.DynamicGroupForm,
    setTemplateNameAutoFillHandler,
    destroyTemplateNameAutoFillHandler,
    isHandlerAccessorDefined,
    templateNameHandle,
    New;

  isHandlerAccessorDefined = function () {
    return !(typeof templateNameHandle === 'undefined');
  };

  setTemplateNameAutoFillHandler = function (options) {
    if (!isHandlerAccessorDefined()) {
      templateNameHandle = new TemplateNameGenerator({
        from: options.from,
        to: options.to,
        withDomElements: true,
      });
    }
    templateNameHandle.run();
  };

  destroyTemplateNameAutoFillHandler = function () {
    if (isHandlerAccessorDefined()) {
      templateNameHandle.destroy();
    }
  };

  New = Content.extend({
    oldNodeProperties: [],
    selectedPuppetModules: [],

    dom: {
      SELECT2_FIELD: '.select2select',
      TEMPLATE_NAME_FROM: '.node-group-name',
      TEMPLATE_NAME_TO: '.node-group-template-name',
      GROUP_TYPE: '#group-type',
      GROUP_PROPERTIES: '#node-group-properties',
      NODE_PROPERTIES: '#node-properties',
      CLONE_BTN: '#clone-btn',
      NODE_GROUP_FORM: '.ngroup-form',
      TYPE_OF_SERVER_SELECTOR: '.type-of-server-selector',
      PUPPET_PROFILES: '.puppet_profiles_placeholder',
      NODE_GROUP_NAME: '#node_group_name',
      CLUSTER_FIELDS: '.cluster-fields',
      CLUSTER_FORM: '.cluster_settings_form',
      LOG_DEBUG: "input:radio[name='cluster_settings[log_debug]']",
      TR_LOG_LEVEL: '.tr_log_level',
      VIRTUAL_TYPE: '#node_group_virtual_type',
      ICONS: '.icon-selector',
      IMPACT_CANCEL: '#impact-form .io-form-action-cancel',
      IMPACT_FORM: '#impact-form',
    },

    /*
      PUBLIC FUNCTIONS
    */
    onDestroy: function () {
      this.dynamicForm.remove();
      this.$(this.dom.GROUP_TYPE).off();
      this.$(this.dom.TEMPLATE_NAME_FROM).off();
      destroyTemplateNameAutoFillHandler();
    },

    events: function () {
      var events = {};

      events['click ' + this.dom.IMPACT_CANCEL] = '_impactCancel';
      events['change ' + this.dom.GROUP_TYPE] = '_displayGroupOptions';
      events['click ' + this.dom.CLONE_BTN] = '_showCloneModal';
      events['submit ' + this.dom.CLUSTER_FORM] =
        '_warnImpactedSlaveNodesOnCluster';
      events['change ' + this.dom.LOG_DEBUG] = '_toggleLogDebug';
      events['change ' + this.dom.VIRTUAL_TYPE] = '_togleIcons';
      events['submit ' + this.dom.NODE_GROUP_FORM] = '_showLoading';
      return events;
    },

    beforeFilter: function () {
      new ClusterVIPS();
      if (typeof lxcGroupIds !== 'undefined') {
        this.currentLxcGroups = lxcGroupIds;
      }
      if (typeof kvmGroupIds !== 'undefined') {
        this.currentKvmGroups = kvmGroupIds;
      }
    },

    render: function () {
      var $select = this.$(this.dom.SELECT2_FIELD),
        self = this;

      this.nodeGroupType = this.$(this.dom.GROUP_TYPE);
      this.nodeGroupProperties = this.$(this.dom.GROUP_PROPERTIES);
      this.nodeProperties = $(this.dom.NODE_PROPERTIES);

      if (!this.dynamicForm) {
        this.dynamicForm = new DynamicGroupForm({ el: this.$el });
      }
      this.dynamicForm.render();

      if (!$select.closest('.hide').length) {
        $select.select2({ placeholder: 'None' });
        $(this.dom.CLUSTER_FIELDS).select2(
          window.select2Defaults({ allowClear: true, placeholder: 'None' }),
        );
      }

      if (
        !this.nodeGroupProperties.closest('.hide').length &&
        this.nodeGroupProperties.length > 0
      ) {
        this.nodeGroupProperties.select2({
          templateResult: function (item) {
            return self._formatProperties(item, nodeGroupPropertiesOptions);
          },
          multiple: true,
        });
      }

      this._setupSelect2PropertiesField(this.nodeProperties);

      this._setAutofillDisplayAndTemplateName();
      PropertyTypeMask.applyMasks.call(this);

      this.oldNodeProperties = $(this.dom.NODE_PROPERTIES).val() || [];

      new ServerTypeWarning({ selector: this.dom.TYPE_OF_SERVER_SELECTOR });
      this.selectedPuppetModules = this._getSelectedPuppetModules();

      $(this.dom.PUPPET_PROFILES).on('select2:select', function () {
        self._profilesChanged();
      });

      $(this.dom.PUPPET_PROFILES).on('select2:unselect', function () {
        self._profilesChanged();
      });

      setTimeout(function () {
        var $puppetProfiles;

        $puppetProfiles = $(
          '.puppet_profiles_container ul.select2-selection__rendered',
        );
        if ($puppetProfiles.length == 0) {
          return;
        }

        Sortable.create($puppetProfiles[0], {
          handle: '.select2-selection__choice',
          onSort: function () {
            var $select2 = $(self.dom.PUPPET_PROFILES);

            $(
              $('.puppet_profiles_container ul')
                .find('.select2-selection__choice')
                .get()
                .reverse(),
            ).each(function () {
              $select2.prepend(
                $select2.find(
                  'option[value="' + $(this).data('select2-id').id + '"]',
                )[0],
              );
            });
            self._profilesChanged();
          },
        });
      }, 500);
    },

    _showLoading: function () {
      $('#rpm-loader-dots > #loader-text').text(
        'Calculating the impact of the suggested change(s)',
      );
      $('#rpm-loader-dots').addClass('visible');
    },

    _impactCancel: function (e) {
      var form = $(this.dom.IMPACT_FORM);

      e.preventDefault();
      form.append('<input name="edit" type="hidden" value="1" />');
      form.submit();
    },

    _currentProfiles: function () {
      var self = this,
        selected = [];

      $(
        '.puppet_profiles_container ul.select2-selection__rendered .select2-selection__choice',
      ).each(function (i, item) {
        selected.push(self._getProfile($(item).attr('title')));
      });

      return selected;
    },

    _profilesChanged: function () {
      var selected = [
        '<input type="hidden" name="node_group[puppet_profile_ids][]" value="" />',
      ];

      this._currentProfiles().map(function (item) {
        selected.push(
          '<input type="hidden" name="node_group[puppet_profile_ids][]" value="' +
            item.value +
            '" />',
        );
      });

      $('.puppet_profiles_values').html(selected.join(''));
    },

    _getProfile: function (name) {
      var filtered = this._puppetProfilesOptions().filter(function (item) {
        return item.label == name;
      });

      return filtered.length > 0 ? filtered[0] : undefined;
    },

    _puppetProfilesOptions: function () {
      var options = $(this.dom.PUPPET_PROFILES + ' option'),
        profiles = [];

      options.each(function (i, item) {
        profiles.push({
          value: $(item).attr('value'),
          label: $(item).text(),
        });
      });

      return profiles;
    },

    _getSelectedPuppetModules: function () {
      return $(this.dom.PUPPET_PROFILES + ' option:selected')
        .map(function () {
          return $(this).text();
        })
        .get();
    },

    _setupAutoFill: function () {
      var name = this.$(this.dom.TEMPLATE_NAME_FROM),
        templateName = this.$(this.dom.TEMPLATE_NAME_TO);

      if (
        templateName.val() === undefined ||
        templateName.val() === '' ||
        templateName.val().replace(/_/g, ' ') === name.val().toLowerCase()
      ) {
        setTemplateNameAutoFillHandler.call(this, {
          from: name,
          to: templateName,
        });
      } else {
        destroyTemplateNameAutoFillHandler();
      }
    },

    _setupSelect2PropertiesField: function (propertyType) {
      var self = this;

      if (!propertyType.closest('.hide').length && propertyType.length > 0) {
        propertyType.select2({
          templateResult: function (item) {
            return self._formatProperties(item, nodePropertiesOptions);
          },
          selectOnBlur: false,
        });
      }
    },

    _setAutofillDisplayAndTemplateName: function () {
      var self = this,
        name = this.$(this.dom.TEMPLATE_NAME_FROM);

      name.on('focus', function () {
        self._setupAutoFill();
      });

      name.on('blur', function () {
        name.off('keyup');
      });

      if (name.is(':focus')) {
        self._setupAutoFill();
      }
    },

    _displayGroupOptions: function () {
      var option = this.$el.find(this.dom.GROUP_TYPE).val();

      this._togleIcons();

      this.$el
        .find(
          '.group-type-dependency-container[data-group-type-dependency*=' +
            option +
            ']',
        )
        .show(0)
        .find('input, select')
        .prop('disabled', false);

      this.$el
        .find(
          '.group-type-dependency-container:not([data-group-type-dependency*=' +
            option +
            '])',
        )
        .hide(0)
        .find('input, select')
        .attr('disabled', 'disabled');

      this.$el
        .find(
          '.properties-dependency-container[data-properties-dependency*=' +
            option +
            ']',
        )
        .show(0)
        .find('input, select')
        .prop('disabled', false);

      this.$el
        .find(
          '.properties-dependency-container:not([data-properties-dependency*=' +
            option +
            '])',
        )
        .hide(0)
        .find('input, select')
        .attr('disabled', 'disabled');
    },

    _formatProperties: function (nodeGroupProperty, options) {
      var nodeGroupPropertyHTML = [],
        $nodeGroupProperty;

      if (!nodeGroupProperty.id) {
        return nodeGroupProperty.text;
      }

      nodeGroupProperty = options[nodeGroupProperty.id];

      nodeGroupPropertyHTML.push('<span class="node-group-properties-option">');
      nodeGroupPropertyHTML.push(
        '<strong>' + nodeGroupProperty.text + '</strong>',
      );
      nodeGroupPropertyHTML.push(
        '<em class="node-group-prop-type">' + nodeGroupProperty.type + '</em>',
      );

      if (nodeGroupProperty.description !== null) {
        nodeGroupPropertyHTML.push(
          '<em> ' + nodeGroupProperty.description + '</em>',
        );
      }

      nodeGroupPropertyHTML.push('</span>');
      $nodeGroupProperty = $(nodeGroupPropertyHTML.join('\n'));
      return $nodeGroupProperty;
    },

    _showCloneModal: function () {
      if (!this.cloneModal) {
        this.cloneModal = new Modal({ id: 'modal-clone', el: '.modal-clone' });
      }

      this.cloneModal.$el.css({
        marginTop: 0,
        top: '10%',
      });
      this.cloneModal.show();
    },

    _togleIcons: function () {
      if (
        $(this.dom.GROUP_TYPE).val() == 'virtual' &&
        $(this.dom.VIRTUAL_TYPE).val() == 'kvm'
      ) {
        $(this.dom.ICONS).removeClass('hidden');
      } else {
        $(this.dom.ICONS).addClass('hidden');
        $(this.dom.ICONS).find('input').prop('checked', false);
      }
    },

    _toggleLogDebug: function (e) {
      var method = $(e.target).val() === 'true' ? 'removeClass' : 'addClass';

      $(this.dom.TR_LOG_LEVEL)[method]('hidden');
    },

    _getClusterAssociationIDs: function () {
      var values = $(this.dom.CLUSTER_FORM).serializeArray(),
        propertyIDs = [],
        virtualIDs = [],
        virtaulRegex = /groups_in_cluster_ids/,
        clusterPropsRegex = /cluster_settings.*[^group]_id/;

      values.forEach(function (row) {
        if (row.value !== '') {
          if (row.name.search(clusterPropsRegex) > -1) {
            propertyIDs.push(row.value);
          } else if (row.name.search(virtaulRegex) > -1) {
            virtualIDs.push(row.value);
          }
        }
      });

      return { properties: $.unique(propertyIDs), virtuals: virtualIDs };
    },

    _warnImpactedSlaveNodesOnCluster: function (e) {
      var url = $(this.dom.NODE_GROUP_FORM).attr('action'),
        form = $(
          "<form action='" +
            url +
            "/impacted_cluster_settings_resources' method='POST'></form>",
        ),
        resourcesIds = this._getClusterAssociationIDs(),
        csrf = $('meta[name=csrf-token]').attr('content'),
        clusterFormId = $(this.dom.CLUSTER_FORM).attr('id');

      if (
        $.isEmptyObject(resourcesIds.properties) &&
        $.isEmptyObject(resourcesIds.virtuals)
      ) {
        return;
      }

      e.preventDefault();
      form.append("<input name='authenticity_token' value='" + csrf + "' />");
      $.each(resourcesIds, function (type) {
        $.each(resourcesIds[type], function (idx, value) {
          form.append("<input name='" + type + "[]' value='" + value + "' />");
        });
      });
      form.append(document.getElementById(clusterFormId).elements);
      document.body.appendChild(form[0]);
      form.submit();
    },

    _updateClusterGroups: function () {
      var updatedGroups = this.$el.find(
          '#cluster_settings_groups_in_cluster_ids',
        ),
        updatedGroupsIdsSorted;

      if (updatedGroups.length > 0 && !(updatedGroups.val() === null)) {
        updatedGroupsIdsSorted = updatedGroups.val().map(Number).sort();

        if (this.currentLxcGroups) {
          this._traverseSortedGroupsToSetDelete(
            this.currentLxcGroups.sort(),
            updatedGroupsIdsSorted,
            'lxc-control',
          );
        }
        if (this.currentKvmGroups) {
          this._traverseSortedGroupsToSetDelete(
            this.currentKvmGroups.sort(),
            updatedGroupsIdsSorted,
            'kvm-config',
          );
        }
      }
    },

    _appendClusterGroupDelete: function (id, groupsType) {
      var idName = '#'.concat(groupsType, '-', id),
        container = this.$el.find(idName);

      container.find('.'.concat(groupsType, '-destroy')).val('true');
    },

    _traverseSortedGroupsToSetDelete: function (
      currentGroups,
      updatedGroups,
      groupsType,
    ) {
      var currentIdx = 0,
        updatedIdx = 0;

      while (currentIdx < currentGroups.length) {
        if (
          updatedIdx >= updatedGroups.length ||
          currentGroups[currentIdx] < updatedGroups[updatedIdx]
        ) {
          this._appendClusterGroupDelete(currentGroups[currentIdx], groupsType);
          currentIdx++;
        } else {
          if (currentGroups[currentIdx] === updatedGroups[updatedIdx]) {
            currentIdx++;
          }
          updatedIdx++;
        }
      }
    },
  });

  exports.New = New;
});
